import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";
import ModificarOperacionNoReportadaModal from "./ModificarOperacionNoReportadaModal";
import ServicioComun from "../../../servicios/Comun";

function OperacionesIncluirOperacionNoReportada({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEditar = false,
  permiteEliminar = false,
  soloLectura = false,
}) {
  const tableRef = useRef();
  const [tiposOperacion, setTiposOperacion] = useState([]);
  const [motivosLiquidacion, setMotivosLiquidacion] = useState([]);

  useEffect(() => {
    const obtengaTiposOperacion = async () => {
      const resultado = await ServicioComun.ObtengaTiposOperacion();
      setTiposOperacion(resultado);
    };

    obtengaTiposOperacion();
  }, []);

  useEffect(() => {
    async function obtenerMotivosLiquidacion() {
      const resultado = await ServicioComun.ObtengaTiposMotivoLiquidacion();
      setMotivosLiquidacion(resultado);
    }

    obtenerMotivosLiquidacion();
  }, []);

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      paging: !permiteEditar,
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
        {
          title: "Editar",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarOperacionNoReportada(operacion) {
              tabla.row(rowIndex).data(operacion).draw(false);
              actualizarOperaciones(tabla.rows().data().toArray());
            }

            ReactDOM.render(
              <div className="d-flex justify-content-between">
                <ModificarOperacionNoReportadaModal
                  operacionNoReportada={cellData}
                  tiposOperacion={tiposOperacion}
                  motivosLiquidacion={motivosLiquidacion}
                  actualizarOperacion={actualizarOperacionNoReportada}
                />
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo Inicial",
          data: "periodoInicio",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
          visible: !permiteEditar && !soloLectura,
        },
        {
          title: "Periodo Final",
          data: "periodoFin",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
          visible: !permiteEditar && !soloLectura,
        },
        {
          title: "Periodo",
          data: "fechaPeriodo",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Tipo de Operación",
          data: "tipoOperacion.descripcion",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Motivo de Liquidación",
          data: "motivoLiquidacion.descripcionLarga",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Fecha de Liquidación",
          data: "fechaLiquidacion",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Saldo Principal Liquidado",
          data: "saldoPrincipalLiquidado",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Saldo de Productos Liquidado",
          data: "saldoProductoLiquidado",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Operación Nueva",
          data: "operacionNueva",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Excluir de Solicitud",
          data: null,
          defaultContent:
            "<button class='btn btn-danger btn-sm js-eliminar'><i class='fa fa-trash'></i></button>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw();
      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [
    operaciones,
    tiposOperacion,
    motivosLiquidacion,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEditar,
    permiteEliminar,
    soloLectura,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesIncluirOperacionNoReportada;
